import { LinearGradient } from 'expo-linear-gradient';
import type { ReactNode } from 'react';
import {
    GRADIENT_COLOR_BOTTOM,
    GRADIENT_COLOR_TOP,
    View,
    YStack,
} from 'smoothie';

import { APP_RIGHT_EDGE } from '../../common/utils/layout';

/**
 * Fruit Slice screens sit on the Fruitful app gradient instead of Grove's
 * default white page. The gradient is pinned to the viewport so it stays put
 * while the page scrolls.
 */
export const FruitSlicePageBackground = ({
    children,
}: {
    children: ReactNode;
}) => {
    return (
        <YStack flex={1} width="100%" minHeight="100%">
            <View
                position="fixed"
                top={0}
                right={APP_RIGHT_EDGE}
                bottom={0}
                left={0}
                pointerEvents="none"
            >
                <LinearGradient
                    colors={
                        [GRADIENT_COLOR_TOP, GRADIENT_COLOR_BOTTOM] as const
                    }
                    style={{ flex: 1 }}
                />
            </View>
            {children}
        </YStack>
    );
};
